import React from "react";
import PropTypes from "prop-types";
import { Bar } from "react-chartjs-2";
import MapaSP from "./Graficos/MapaSP copy 3.jsx";

import {
  Chart as ChartJS,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
} from "chart.js";

ChartJS.register(Tooltip, Legend, CategoryScale, LinearScale, BarElement);

// Configuração global Chart.js
ChartJS.defaults.color = "#000";
ChartJS.defaults.font.family =
  "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif";
ChartJS.defaults.font.size = 12;

const Graficos = ({ dadosCards, onCidadeClick, cidadeSelecionada }) => {
  const tituloResumo = cidadeSelecionada
    ? `Resumo Geral – ${cidadeSelecionada}`
    : "Resumo Geral";

  const labelsColo = [
    "Mulheres Rastreadas para Câncer do Colo do Útero",
    "Agendar Primeira Citologia",
    "Citologia Atrasada",
  ];

  const labelsMama = [
    "Mulheres Rastreadas para Câncer de Mama",
    "Agendar Primeira Mamografia",
    "Mamografia Atrasada",
  ];

  const valoresColo = [
    dadosCards?.total_controle_colo || 0,
    dadosCards?.total_agendar_primeiro_papa || 0,
    dadosCards?.total_papa_atrasado || 0,
  ];

  const valoresMama = [
    dadosCards?.total_controle_mama || 0,
    dadosCards?.total_agendar_primeira_mamografia || 0,
    dadosCards?.total_mamografia_atrasada || 0,
  ];

  const chartJsColors = ["#1b2850", "#00cfe8", "#ff9f43"];

  // Escala única para os dois gráficos
  const maiorValor = Math.ceil(Math.max(...valoresColo, ...valoresMama) * 1.3); // Configuração padrão idêntica
  const optionsBar = {
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: "y",
    layout: {
      padding: 10,
    },
    plugins: {
      legend: { display: false },
      datalabels: {
        formatter: (value) => Number(value).toLocaleString("pt-BR"),

        color: (context) => {
          const value = context.dataset.data[context.dataIndex];
          const max = context.chart.scales.x.max;

          // Se for menor que 8% do gráfico → texto preto
          if (value < max * 0.08) {
            return "#000000";
          }

          return "#ffffff";
        },

        anchor: (context) => {
          const value = context.dataset.data[context.dataIndex];
          const max = context.chart.scales.x.max;

          return value < max * 0.08 ? "end" : "center";
        },

        align: (context) => {
          const value = context.dataset.data[context.dataIndex];
          const max = context.chart.scales.x.max;

          // Se barra pequena → joga para fora
          return value < max * 0.08 ? "right" : "center";
        },

        clamp: true,
        clip: false,

        font: {
          weight: "bold",
          size: 12,
        },
      },
    },
    scales: {
      x: {
        beginAtZero: true,
        max: maiorValor,
        grid: {
          color: "#e9ecef",
        },
        ticks: {
          callback: function (value) {
            return Number(value).toLocaleString("pt-BR");
          },
        },
      },
      y: {
        grid: {
          display: false,
        },
      },
    },
  };

  const datasetConfig = {
    backgroundColor: chartJsColors,
    borderColor: chartJsColors,
    borderWidth: 1,
    barThickness: 60,
    categoryPercentage: 0.8,
    barPercentage: 0.9,
  };

  const dataBarColo = {
    labels: labelsColo,
    datasets: [
      {
        label: "Total",
        data: valoresColo,
        ...datasetConfig,
      },
    ],
  };

  const dataBarMama = {
    labels: labelsMama,
    datasets: [
      {
        label: "Total",
        data: valoresMama,
        ...datasetConfig,
      },
    ],
  };

  return (
    <div className="row g-3 h-100">
      {/* MAPA */}
      <div className="col-12 col-lg-7 h-100 d-flex">
        <div className="card shadow-sm flex-fill d-flex flex-column">
          <div className="card-header bg-light">
            <h6 className="mb-0">DRS XIV – São João da Boa Vista</h6>
          </div>

          <div className="card-body p-2 flex-fill d-flex">
            <div className="w-100 h-100">
              <MapaSP onCidadeClick={onCidadeClick} />
            </div>
          </div>
        </div>
      </div>

      {/* GRÁFICOS */}
      <div className="col-12 col-lg-5 h-100 d-flex flex-column gap-3">
        {/* COLO */}
        <div className="card shadow-sm flex-fill d-flex flex-column">
          <div className="card-header bg-light">
            <h6 className="mb-0">
              {tituloResumo}
              <br />
              <small className="text-muted">
                Rastreamento – Câncer do Colo do Útero
              </small>
            </h6>
          </div>

          <div className="card-body" style={{ height: "300px" }}>
            <Bar data={dataBarColo} options={optionsBar} />
          </div>
        </div>

        {/* MAMA */}
        <div className="card shadow-sm flex-fill d-flex flex-column">
          <div className="card-header bg-light">
            <h6 className="mb-0">
              {tituloResumo}
              <br />
              <small className="text-muted">
                Rastreamento – Câncer de Mama
              </small>
            </h6>
          </div>

          <div className="card-body" style={{ height: "300px" }}>
            <Bar data={dataBarMama} options={optionsBar} />
          </div>
        </div>
      </div>
    </div>
  );
};

Graficos.propTypes = {
  dadosCards: PropTypes.object,
  onCidadeClick: PropTypes.func,
  cidadeSelecionada: PropTypes.string,
};

export default Graficos;
